export const DEFAULT_NB_FRAMES_PICTURE = 48
